import { useState } from "react";

import { HorizontalMenu } from "@/components/ui/HorizontalMenu";

import { PitchHistory } from "../CoachMode/PitchHistory";
import { QuickTileChangeModal } from "../Tagging/components/modals/QuickTileChangeModal";
import { LiveView } from "./LiveView";

type Tab = "Live View" | "Pitch History";

const ChallengeModeView = () => {
  const [activeTab, setActiveTab] = useState<Tab>("Live View");

  return (
    <div className="flex h-full flex-col">
      <div className="pt-2">
        <HorizontalMenu
          items={[
            {
              label: "Live View",
              active: activeTab === "Live View",
              onClick: () => setActiveTab("Live View"),
            },
            {
              label: "Pitch History",
              active: activeTab === "Pitch History",
              onClick: () => setActiveTab("Pitch History"),
            },
          ]}
        />
      </div>

      <div className="flex-1 overflow-y-auto pt-4">
        {activeTab === "Live View" && <LiveView />}
        {activeTab === "Pitch History" && <PitchHistory />}
      </div>

      <QuickTileChangeModal excludeVisualizations />
    </div>
  );
};

export default ChallengeModeView;
